import { useEffect } from 'react';
import { useGoogleAnalytics } from '../../hooks/useGoogleAnalytics';

const Analytics = () => {
  // Initialize Google Analytics tracking
  useGoogleAnalytics();
  
  useEffect(() => {
    // Set up global error tracking
    window.addEventListener('error', (event) => {
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'exception', {
          description: event.error?.message || 'Unknown error',
          fatal: false
        });
      }
    });

    // Set up unhandled promise rejection tracking
    window.addEventListener('unhandledrejection', (event) => {
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'exception', {
          description: event.reason?.message || 'Unhandled promise rejection',
          fatal: false
        });
      }
    });

    // Track performance metrics
    if ('performance' in window && 'getEntriesByType' in window.performance) {
      window.addEventListener('load', () => {
        setTimeout(() => {
          const navigation = window.performance.getEntriesByType('navigation')[0];
          if (navigation && typeof window.gtag !== 'undefined') {
            window.gtag('event', 'timing_complete', {
              name: 'page_load_time',
              value: Math.round(navigation.loadEventEnd - navigation.loadEventStart)
            });
          }
        }, 0);
      });
    }
  }, []);

  return null; // This component doesn't render anything
};

export default Analytics;
